module.exports = __webpack_public_path__ + "static/malik-b0b668987830c5a77840967a75a5fb88.jpg";